import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["running-cadence"]!;

export function Body() {
  return (
    <>
      <p>
        Cadence, the number of steps you take per minute, is one of the most discussed parts of
        running technique. Should you change yours? Research shows what happens in the body when
        you do.
      </p>

      <h2>What the researchers did</h2>
      <p>
        In one study, 45 healthy recreational runners ran on a treadmill at the same speed with
        their normal cadence, and with a cadence 5 and 10 percent higher and lower. The
        researchers measured the load on the hip, knee and ankle.
      </p>
      <p>
        A systematic review from 2014 collected ten studies that changed stride frequency or
        stride length at a constant speed.
      </p>

      <h2>What they found</h2>
      <p>
        With a 5 or 10 percent higher cadence, the knee absorbed less energy on each step. At 10
        percent higher, the hip did too. The steps got shorter, the body bounced up and down less
        and the braking force decreased. When cadence was lowered by 10 percent, the load on all
        joints increased.
      </p>
      <p>
        The review found the same pattern: a higher step rate, with shorter steps, reduced several
        biomechanical factors that are linked to running injuries.
      </p>

      <h2>What it means for you</h2>
      <p>
        You don't need a particular number. Cadence varies with height, speed and terrain. But if
        you have recurring knee or hip pain, or take long steps that land well in front of your
        body, a small increase of around 5 percent may reduce the load.
      </p>
      <p>
        Change it gradually, for example with a metronome on part of your easy runs, and let it
        become natural over some weeks.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The studies measured load during running, not whether runners got fewer injuries over
        time. Most were small and included mostly men. A changed cadence can also feel tiring at
        first.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training doesn't give you a cadence target. If you work on your cadence, do it on easy
        runs, and keep your pace targets for the sessions where pace is the point.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Heiderscheit et al. (2011), Effects of step rate manipulation on joint mechanics during
          running.{" "}
          <a href="https://doi.org/10.1249/MSS.0b013e3181ebedf4">Medicine & Science in Sports & Exercise</a>.
        </li>
        <li>
          Schubert, Kempf & Heiderscheit (2014), Influence of stride frequency and length on
          running mechanics: a systematic review.{" "}
          <a href="https://doi.org/10.1177/1941738113508544">Sports Health</a>.
        </li>
      </ul>
    </>
  );
}
